import TerminalHeader from './TerminalHeader'

export default TerminalHeader
